export interface BatchConfig {
    bgType: 'color' | 'image' | 'transparent';
    bgColor: string;
    bgImage: File | null;
    blur: number;
}

export async function applyBatchConfig(originalFile: File, processedFile: File, config: BatchConfig): Promise<File> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Could not get 2d context');

    // Load foreground (processed transparent image)
    const fgImg = new Image();
    const fgUrl = URL.createObjectURL(processedFile);
    fgImg.src = fgUrl;
    await new Promise(resolve => fgImg.onload = resolve);

    canvas.width = fgImg.width;
    canvas.height = fgImg.height;

    // 1. Draw Background
    if (config.bgType === 'color') {
        ctx.fillStyle = config.bgColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    } else if (config.bgType === 'image' && config.bgImage) {
        const bgImg = new Image();
        const bgUrl = URL.createObjectURL(config.bgImage);
        bgImg.src = bgUrl;
        await new Promise(resolve => bgImg.onload = resolve);
        ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(bgUrl);
    } else if (config.bgType === 'transparent') {
        // Already transparent, do nothing for background
    }

    // 2. Draw Blurred Subjects (behind the main subject) if blur > 0
    if (config.blur > 0) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const tempCtx = tempCanvas.getContext('2d');
        if (tempCtx) {
            tempCtx.filter = `blur(${config.blur / 5}px)`;
            tempCtx.drawImage(fgImg, 0, 0);
            ctx.drawImage(tempCanvas, 0, 0);
        }
    }

    // 3. Draw Foreground
    ctx.drawImage(fgImg, 0, 0);
    URL.revokeObjectURL(fgUrl);

    const [fileName] = originalFile.name.split('.');
    const blob = await new Promise<Blob>((resolve) => canvas.toBlob(b => resolve(b!), 'image/png'));
    return new File([blob], `${fileName}-processed.png`, { type: 'image/png' });
}
